import { MinusIcon, PlusIcon } from '@heroicons/react/20/solid';

interface Props {
  error: boolean;
  onChange: (val: number) => void;
  value: number;
}

const FormCounter = ({ error, onChange, value }: Props) => {
  return (
    <div className="flex gap-[1.6rem]">
      <div className="flex items-center rounded-[1.5rem] bg-brand-lightest-gray px-6 py-4">
        <button
          onClick={() => onChange(value - 1)}
          type="button"
          className="flex min-h-[3.4rem] min-w-[3.4rem] items-center justify-center rounded-full bg-white text-[2.4rem] font-semibold"
        >
          <MinusIcon className="h-8 w-8 text-black" />
        </button>

        <input
          className={`w-[8.8rem] rounded-brand border-none bg-inherit p-0 text-center text-[1.6rem] font-semibold leading-input text-inherit placeholder-gray-300  focus:ring-0 sm:text-input ${
            error ? 'text-red-500' : ''
          }`}
          type="number"
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        />

        <button
          type="button"
          className="flex min-h-[3.4rem] min-w-[3.4rem] items-center justify-center rounded-full border-none bg-brand-secondary text-[2.4rem] font-semibold text-white"
          onClick={() => onChange(value + 1)}
        >
          <PlusIcon className="h-8 w-8  text-white" />
        </button>
      </div>
    </div>
  );
};

FormCounter.displayName = 'FormCounter';
export default FormCounter;
